var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "mb5" },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px", float: "right" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "280px", "margin-right": "15px" },
                attrs: {
                  "end-placeholder": _vm.$t("operationCenter.endDate"),
                  "start-placeholder": _vm.$t("operationCenter.startDate"),
                  "range-separator": "~",
                  size: "small",
                  type: "daterange",
                  "value-format": "yyyy-MM-dd",
                },
                model: {
                  value: _vm.queryDateTime,
                  callback: function ($$v) {
                    _vm.queryDateTime = $$v
                  },
                  expression: "queryDateTime",
                },
              }),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.entrySearch },
                },
                [_vm._v(_vm._s(_vm.$t("operationCenter.Procurar")) + " ")]
              ),
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.entrySearch } },
                [_vm._v(_vm._s(_vm.$t("operationCenter.reset")))]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "table-title",
              staticStyle: { "margin-bottom": "20px" },
            },
            [_vm._v(" 服务质量与时效 Qtd. de serviço e prazos ")]
          ),
          _c("div", { staticClass: "table-container" }, [
            _c("div", { staticClass: "table-row" }, [
              _c("div", { staticClass: "table-cell header-cell" }, [
                _vm._v("下单量(Qtd. dos pedidos)"),
              ]),
              _c("div", { staticClass: "table-cell header-cell" }, [
                _vm._v("出仓量(Qtd. de saída da encomenda)"),
              ]),
              _c("div", { staticClass: "table-cell header-cell" }, [
                _vm._v("揽收量(Coletas realizadas)"),
              ]),
              _c("div", { staticClass: "table-cell header-cell" }, [
                _vm._v("揽收率(Porcentagem de coleta)"),
              ]),
              _c("div", { staticClass: "table-cell header-cell" }, [
                _vm._v("准时揽收量(Coletas pontuais)"),
              ]),
              _c("div", { staticClass: "table-cell header-cell" }, [
                _vm._v("准时揽收率(Porcentagem de coleta pontual)"),
              ]),
              _c("div", { staticClass: "table-cell header-cell" }, [
                _vm._v("妥投量(Entregas concluídas)"),
              ]),
              _c("div", { staticClass: "table-cell header-cell" }, [
                _vm._v("理应送达量(Qtd. do pacote deve ser entregue)"),
              ]),
              _c("div", { staticClass: "table-cell header-cell" }, [
                _vm._v("妥投率(Porcentagem de entrega)"),
              ]),
              _c("div", { staticClass: "table-cell header-cell" }, [
                _vm._v("准时妥投量(Entregas pontuais)"),
              ]),
              _c("div", { staticClass: "table-cell header-cell" }, [
                _vm._v("准时妥投率(Porcentagem de entrega pontual)"),
              ]),
              _c("div", { staticClass: "table-cell header-cell" }, [
                _vm._v("P90"),
              ]),
            ]),
            _c("div", { staticClass: "table-row" }, [
              _c("div", { staticClass: "table-cell data-cell" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.serviceQuality.totalOrderCount.toLocaleString() || 0
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "table-cell data-cell" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.serviceQuality.outboundCount.toLocaleString() || 0
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "table-cell data-cell" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.serviceQuality.collectCount.toLocaleString() || 0
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "table-cell data-cell" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      (
                        (parseFloat(_vm.serviceQuality.collectRate) || 0) * 100
                      ).toFixed(2) + "%"
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "table-cell data-cell" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.serviceQuality.collectOnTimeCount.toLocaleString() ||
                        0
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "table-cell data-cell" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      (
                        (parseFloat(_vm.serviceQuality.collectOnTimeRate) ||
                          0) * 100
                      ).toFixed(2) + "%"
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "table-cell data-cell" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.serviceQuality.deliveryCount.toLocaleString() || 0
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "table-cell data-cell" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.serviceQuality.shouldDeliveryCount.toLocaleString() ||
                        0
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "table-cell data-cell" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      (
                        (parseFloat(_vm.serviceQuality.deliveryRate) || 0) * 100
                      ).toFixed(2) + "%"
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "table-cell data-cell" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.serviceQuality.deliveryOnTimeCount.toLocaleString() ||
                        0
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "table-cell data-cell" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      (
                        (parseFloat(_vm.serviceQuality.deliveryOnTimeRate) ||
                          0) * 100
                      ).toFixed(2) + "%"
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "table-cell data-cell" }, [
                _vm._v(_vm._s(_vm.serviceQuality.p90 || 0)),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "table-title" }, [
            _vm._v("数据质量与异常 Qualidade de dados e exceções"),
          ]),
          _c("div", { staticClass: "table-container" }, [
            _c("div", { staticClass: "table-row" }, [
              _c("div", { staticClass: "table-cell header-cell" }, [
                _vm._v("确认丢失量(Perdas confirmadas)"),
              ]),
              _c("div", { staticClass: "table-cell header-cell" }, [
                _vm._v("丢失率(Porcentagem da perda)"),
              ]),
              _c("div", { staticClass: "table-cell header-cell" }, [
                _vm._v("破损量(Encomendas danificadas)"),
              ]),
              _c("div", { staticClass: "table-cell header-cell" }, [
                _vm._v("破损率(Porcentagem de danos)"),
              ]),
              _c("div", { staticClass: "table-cell header-cell" }, [
                _vm._v("虚假签收量(Fake deliveries)"),
              ]),
              _c("div", { staticClass: "table-cell header-cell" }, [
                _vm._v("虚假签收率(Porcentagem de fake d deliveries)"),
              ]),
              _c("div", { staticClass: "table-cell header-cell" }, [
                _vm._v(
                  " 轨迹断更超20天量(Rastreamento sem atualização há 20 dias) "
                ),
              ]),
              _c("div", { staticClass: "table-cell header-cell" }, [
                _vm._v("超时效未闭环量(Casos fora do prazo não concluídos)"),
              ]),
              _c("div", { staticClass: "table-cell header-cell" }, [
                _vm._v("轨迹完整率(Rastreamentos completos)"),
              ]),
              _c("div", { staticClass: "table-cell header-cell" }, [
                _vm._v(
                  " 轨迹签收推送率(Porcentagem de envio de rastreio e assinatura) "
                ),
              ]),
              _c("div", { staticClass: "table-cell header-cell" }, [
                _vm._v(
                  " 轨迹签收推送准时率(Porcentagem de pontualidade do envio de rastreio de assinatura) "
                ),
              ]),
              _c("div", { staticClass: "table-cell header-cell" }, [
                _vm._v("签收pdd推送率(de impulso de assinatura PDD)"),
              ]),
            ]),
            _c("div", { staticClass: "table-row" }, [
              _c("div", { staticClass: "table-cell data-cell" }, [
                _vm._v(_vm._s(_vm.dataQuality.lostCount.toLocaleString() || 0)),
              ]),
              _c("div", { staticClass: "table-cell data-cell" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      (
                        (parseFloat(_vm.dataQuality.lostRate) || 0) * 100
                      ).toFixed(2) + "%"
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "table-cell data-cell" }, [
                _vm._v(
                  _vm._s(_vm.dataQuality.damagedCount.toLocaleString() || 0)
                ),
              ]),
              _c("div", { staticClass: "table-cell data-cell" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      (
                        (parseFloat(_vm.dataQuality.damagedRate) || 0) * 100
                      ).toFixed(2) + "%"
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "table-cell data-cell" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.dataQuality.fakeSignCount.toLocaleString() || 0
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "table-cell data-cell" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      (
                        (parseFloat(_vm.dataQuality.fakeSignRate) || 0) * 100
                      ).toFixed(2) + "%"
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "table-cell data-cell" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.dataQuality.trackBreakCount.toLocaleString() || 0
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "table-cell data-cell" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.dataQuality.timeoutUnclosedCount.toLocaleString() || 0
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "table-cell data-cell" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      (
                        (parseFloat(_vm.dataQuality.trackIntactRate) || 0) * 100
                      ).toFixed(2) + "%"
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "table-cell data-cell" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      (
                        (parseFloat(_vm.dataQuality.trackSignPushRate) || 0) *
                        100
                      ).toFixed(2) + "%"
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "table-cell data-cell" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      (
                        (parseFloat(_vm.dataQuality.trackSignPushOnTimeRate) ||
                          0) * 100
                      ).toFixed(2) + "%"
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "table-cell data-cell" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      (
                        (parseFloat(_vm.dataQuality.signPodPushRate) || 0) * 100
                      ).toFixed(2) + "%"
                    ) +
                    " "
                ),
              ]),
            ]),
          ]),
          _c(
            "div",
            {
              staticStyle: {
                float: "right",
                position: "relative",
                "z-index": "9",
              },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.exportData },
                },
                [_vm._v(_vm._s(_vm.$t("operationCenter.exports")) + " ")]
              ),
            ],
            1
          ),
          _c(
            "el-tabs",
            {
              attrs: { type: "card" },
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                {
                  key: 1,
                  attrs: { label: "客户 Plataforma", name: "customerTime" },
                },
                [
                  _vm.isShow1
                    ? _c("customerTime", {
                        attrs: {
                          "data-quality-for-customer-list":
                            _vm.dataQualityForCustomerList,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  key: 0,
                  attrs: { label: "大区 Região", name: "regionalTimeliness" },
                },
                [
                  _vm.isShow
                    ? _c("regionalTimeliness", {
                        attrs: {
                          "data-quality-for-region-list":
                            _vm.dataQualityForRegionList,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-pagination", {
            staticStyle: { margin: "10px 0", float: "right" },
            attrs: {
              "current-page": _vm.pageParam.pageNumber,
              "page-size": _vm.pageParam.pageSize,
              "page-sizes": [10, 20, 50, 100],
              total: _vm.pageParam.total,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }